import { useEffect, useState } from 'react'
import { AutoFilter, PillFilters } from './PillFilters'
import { useAuth } from '../auth'
import { fetchApiJson } from '@inmagik/react-crud'
import { API_URL } from '../constants'
import { getLabelTipoBilancia } from '../utils/utils'

type Props = {
  filters: Record<string, string | number>
  setFilters: (filters: Record<string, string | number>) => void
}

export function FiltriBilance({ filters, setFilters }: Props) {
  const [clienteFilter, setClienteFilter] = useState('')
  const [sedeFilter, setSedeFilter] = useState('')

  const { tokens } = useAuth()

  useEffect(() => {
    if (filters.cliente) {
      fetchApiJson(
        `${API_URL}/bilance/cliente/options/?id=${filters.cliente}`,
        {
          headers: {
            Authorization: `Bearer ${tokens?.access}`,
          },
        }
      ).then((data) => {
        setClienteFilter(data[0]?.label)
      })
    }
  }, [filters.cliente])

  useEffect(() => {
    if (filters.sede) {
      fetchApiJson(`${API_URL}/bilance/sede/options/?id=${filters.sede}`, {
        headers: {
          Authorization: `Bearer ${tokens?.access}`,
        },
      }).then((data) => {
        setSedeFilter(data[0]?.label)
      })
    }
  }, [filters.sede])

  return (
    <PillFilters
      filters={filters}
      removeFilter={(name) => setFilters({ [name]: '', page: 1 })}
    >
      <AutoFilter name="cliente" caption={clienteFilter} />
      <AutoFilter name="sede" caption={sedeFilter} />
      <AutoFilter
        name="tipo_bilancia"
        caption={getLabelTipoBilancia(filters.tipo_bilancia as string) ?? ''}
      />
      <AutoFilter name="rapporto_taratura" caption="Rapporto taratura" />
      <AutoFilter name="verif_periodica" caption="Verifica periodica" />
      <AutoFilter
        name="data_scadenza_periodica__gte"
        label="Scadenza periodica da"
      />
      <AutoFilter
        name="data_scadenza_periodica__lte"
        label="Scadenza periodica a"
      />
      <AutoFilter
        name="data_scadenza_taratura__gte"
        label="Scadenza taratura da"
      />
      <AutoFilter
        name="data_scadenza_taratura__lte"
        label="Scadenza taratura a"
      />
      <AutoFilter
        name="con_richiesta_periodica"
        caption={
          filters.con_richiesta_periodica === 'true'
            ? 'Con richiesta periodica'
            : 'Senza richiesta periodica'
        }
      />
      <AutoFilter
        name="data_richiesta_periodica__gte"
        label="Richiesta periodica da"
      />
      <AutoFilter
        name="data_richiesta_periodica__lte"
        label="Richiesta periodica a"
      />
      <AutoFilter
        name="data_intervento_periodica_aperto__isnull"
        caption={
          Boolean(filters.data_intervento_periodica_aperto__isnull)
            ? 'Intervento verificazione periodica non programmato'
            : 'Intervento verificazione periodica programmato'
        }
      />
      <AutoFilter
        name="data_intervento_periodica_aperto__gte"
        label="Intervento verificazione periodica da"
      />
      <AutoFilter
        name="data_intervento_periodica_aperto__lte"
        label="Intervento verificazione periodica a"
      />
      <AutoFilter
        name="data_intervento_taratura_aperto__isnull"
        caption={
          Boolean(filters.data_intervento_taratura_aperto__isnull)
            ? 'Intervento taratura non programmato'
            : 'Intervento taratura programmato'
        }
      />
      <AutoFilter
        name="data_intervento_taratura_aperto__gte"
        label="Intervento taratura da"
      />
      <AutoFilter
        name="data_intervento_taratura_aperto__lte"
        label="Intervento taratura a"
      />
      <AutoFilter
        name="fuori_uso"
        caption={
          filters.fuori_uso !== ''
            ? filters.fuori_uso === 'true'
              ? 'Bilance fuori uso'
              : 'Bilance in uso'
            : ''
        }
      />
      <AutoFilter
        name="dismessa"
        caption={
          filters.dismessa !== ''
            ? filters.dismessa === 'true'
              ? 'Bilance dismesse'
              : 'Bilance non dismesse'
            : ''
        }
      />
      <AutoFilter
        caption={
          filters.autoprodotta !== ''
            ? filters.autoprodotta === 'true'
              ? 'Bilance autoprodotte'
              : 'Bilance non autoprodotte'
            : ''
        }
        name="autoprodotta"
      />
    </PillFilters>
  )
}
